module.exports = __webpack_public_path__ + "img/document-download-red.7f263ff4.svg";